function toggleDarkScheme(value: boolean) {
  document.documentElement.classList.toggle("wa-dark", value);
}

function init() {
  const prefersDarkQuery = window.matchMedia("(prefers-color-scheme: dark)");
  toggleDarkScheme(prefersDarkQuery.matches);
  prefersDarkQuery.addEventListener("change", (event) => {
    toggleDarkScheme(event.matches);
  });
}

init();
